import styled from 'styled-components'
import { BlogThreshold as Threshold } from '../../constants/theme'

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  margin: 26px 0 55px;
  .header {
    max-width: 100%;
    margin-bottom: 38px;
  }

  .previews {
    display: flex;
    flex-wrap: wrap;
    margin-right: -${props => (props.previewGap || 0)}px;
    justify-content: center;

    @media (max-width: ${Threshold.phone}) {
      margin-right: -${props => (props.previewGapPhone || 0)}px;
    }
  }
  .btn {
    margin-top: 26px;
    align-self: center;

    @media (max-width: ${Threshold.phone}) {
      margin-top: 0;
    }
  }
`
